import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Careers = () => {
  const openPositions = [
    {
      title: 'Senior Full Stack Developer',
      department: 'Engineering',
      location: 'Remote',
      type: 'Full-time',
      description: 'Join our engineering team to build and scale our dating platform using React, Node.js, and Python.'
    },
    {
      title: 'Product Designer',
      department: 'Design',
      location: 'Remote',
      type: 'Full-time',
      description: 'Create beautiful, intuitive user experiences that help people find meaningful connections.'
    },
    {
      title: 'Data Scientist',
      department: 'Data',
      location: 'Remote',
      type: 'Full-time',
      description: 'Develop and improve our matching algorithms to help users find compatible partners.'
    },
    {
      title: 'Customer Success Manager',
      department: 'Support',
      location: 'Remote',
      type: 'Full-time',
      description: 'Help our users have the best experience possible and build lasting relationships.'
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Join Our Team</h1>
          <p className="lead text-muted">
            Help us build the future of meaningful connections. We're looking for passionate 
            people who want to make a difference in how people meet and form relationships.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={4} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100 text-center">
            <Card.Body className="p-4">
              <i className="bi bi-globe display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Remote First</h5>
              <p className="text-muted mb-0">
                Work from anywhere in the world. We believe great talent isn't limited by geography.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100 text-center">
            <Card.Body className="p-4">
              <i className="bi bi-heart display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Meaningful Work</h5>
              <p className="text-muted mb-0">
                Help millions of people find love and build lasting relationships.
              </p>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4}>
          <Card className="border-0 shadow-sm h-100 text-center">
            <Card.Body className="p-4">
              <i className="bi bi-graph-up display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Growth Opportunities</h5>
              <p className="text-muted mb-0">
                Learn and grow with a fast-paced startup that values your development.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2 className="fw-bold mb-4">Open Positions</h2>
        </Col>
      </Row>

      <Row>
        {openPositions.map((position, index) => (
          <Col lg={6} key={index} className="mb-4">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h5 className="fw-bold mb-0">{position.title}</h5>
                  <span className="badge bg-primary">{position.type}</span>
                </div>
                <div className="mb-3">
                  <span className="text-muted me-3">
                    <i className="bi bi-building me-1"></i>
                    {position.department}
                  </span>
                  <span className="text-muted">
                    <i className="bi bi-geo-alt me-1"></i>
                    {position.location}
                  </span>
                </div>
                <p className="text-muted mb-3">{position.description}</p>
                <Button variant="outline-primary" size="sm">
                  Learn More
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="justify-content-center mt-5">
        <Col lg={8} className="text-center">
          <Card className="border-0 shadow-sm bg-primary text-white">
            <Card.Body className="p-5">
              <h3 className="fw-bold mb-3">Don't See Your Role?</h3>
              <p className="mb-4">
                We're always looking for talented individuals. Send us your resume and 
                tell us how you can contribute to our mission.
              </p>
              <Button variant="light" href="mailto:careers@paperdate.io">
                <i className="bi bi-envelope me-2"></i>
                Contact Us
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Careers;

